<template>
  <div class="row caso_sucesso">
    <div class="alumni_circulo"
        :style="{backgroundImage: `url(${imageurl})`}"></div>
    <h1 class="aspaItem" :class="colorclass">“</h1>
    <div class="alumni_text defaultcolor" 
      :class="colorclass">
      <p>{{formatedCitacao}}</p>
    </div>
  </div>
</template>

<script>
import constants from "@/constants.js";

export default {
  props:["imageurl","citacao","colorclass"],
  computed:{
    formatedCitacao(){
      return this.truncate(this.citacao,constants.maxChars," (...)");
    }
  },
  methods:{
    truncate(str, max, suffix){
      return str.length < max ?
          str :
          `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`
    }
  }
};
</script>

<style scoped>

.row{
  margin-left: 0;
  margin-right: 0;
}

.alumni_circulo {
  width: 120px;
  height: 120px;
  right: 75%;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0 auto;
  margin-bottom: 0px;
  margin-top: 10px;
  text-shadow: 0 0 black;
  -webkit-box-shadow: 2px 4px 17px -8px #2e2e2e;
  box-shadow: 2px 4px 17px -8px #786f6f;
  z-index: 2;
}

.caso_sucesso h1 {
  font-family: 'Montserrat Light',serif;
  z-index: 5;
  position: absolute;
  padding-left: 80px;
  margin-top: -14px;
  font-size: 176px;
}

.alumni_text {
  width: 100%;
  padding-right: 20px;
  position: relative;
  border-radius: 8px;
  padding: 1em;
  margin-bottom: 45px;
  border-radius: 8px 8px 0px 0px;
  margin-bottom: -12px;
  background-color: white;
  margin-top: -70px;
}


.alumni_text p {
  font-size: 20px;
  width: 100%;
  line-height: 2;
  padding: 30px 80px;
  color: #fefefe;
  font-family: 'Montserrat';
  font-size: 17px;
  color: #45464A;
  padding-top: 70px;
  padding-bottom: 0px;
}

.caso_sucesso {
  padding-top: 75px;
}

.imagem_caso_sucesso {
  z-index: 2;
}


@media (min-width : 768px) and (max-width : 1024px) {

  .alumni_text p {
    font-size: 15px;
    padding-right: 25px;
    padding-left: 25px;
  }

  .alumni_circulo {
    width: 100px;
    height: 100px;
  }

  .caso_sucesso h1 {
    margin-top: -34px;
  }

}

@media (max-width: 767px) {

  .caso_sucesso {
    padding-top: 15px;
  }

  .alumni_circulo {
    width: 80px;
    height: 80px;
  }

  .alumni_text p {
    font-size: 13px;
    padding-right: 20px;
    padding-left: 20px;
    line-height: 1.6;
    padding-top: 40px;
  }

  .caso_sucesso h1 {
    font-size: 130px;
  }

  .balao_info_caso_sucesso {
    padding-right: 0px;
    padding-left: 0px;
  }

  .caso_sucesso h1 {
    padding-left: 30px;
    margin-top: -10px;
  }

  .alumni_text {
    margin-top: -45px;
    padding-bottom: 8px;
  }
}

</style>
